<template>
	<div class="header">
		<div class="logo-row">
			<div class="img-ctr">
				<img class="logo" :src="logo" @click="clickLogo()" />
				<img class="slogan" src="https://syzsoss.oss-cn-chengdu.aliyuncs.com/web/slogon2.gif" />
			</div>

			<div class="user-ctr">

				<div v-if="user" class="user-info-ctr">
					<img v-if="user.avatar" :src="user.avatar" class="user-avatar" @click="openUserDialog()"/>
					<div class="user-info" @click="openUserDialog()">{{ user.parent ? user.parent.nickname + '（' + user.nickname + '）' : user.nickname}}</div>
					
					<img src="https://syzsoss.oss-cn-chengdu.aliyuncs.com/202610/27165845-21392984679077057.png" class="edit" @click="openUserDialog()"/>
					
					<div class="header-login-btn-change" @click="clickLogin()">切换登录</div>
				</div>
				
				
				
				<div v-else class="header-login-btn" @click="clickLogin()">登录</div>
			</div>
		</div>

		<div class="nav-row">
			<div class="nav-container">
				<!-- 一级菜单 -->
				<div v-for="(item, index) in menus" class="nav-item-wrapper" :key="index"
					@mouseenter="hoverMenuIndex = index" @mouseleave="hoverMenuIndex = -1">

					<div class="nav-item" :class="{'active-nav': activeMenu == index}" @click="changeMenu(index)">
						{{ item.name }}
						<!-- 有子菜单时显示箭头 -->
						<span v-if="item.children && item.children.length > 0" class="arrow-down">▼</span>
					</div>

					<!-- 下拉子菜单 -->
					<div v-if="item.children && item.children.length > 0 && hoverMenuIndex === index"
						class="dropdown-menu">
						<div v-for="(child, childIndex) in item.children" :key="childIndex" class="dropdown-item"
							:class="{'active-dropdown': activeChildMenu === index + '-' + childIndex}"
							@click="changeChildMenu(index, childIndex)">
							{{ child.name }}
						</div>
					</div>
				</div>
			</div>
		</div>


		<el-dialog title="欢迎登录职教数" :visible.sync="loginStore.isLoginDialogVisible" width="45%" align="center">
			<div v-if="loginType == 'sms'" class="sms-ctr">
				<el-form>
					<div class="form-item-ctr">
						<el-form-item label="手机号">
							<input v-model="phone" class="login-user-form" required name="phone" placeholder="请输入手机号" />
						</el-form-item>
					</div>

					<div class="form-item-ctr">
						<el-form-item label="验证码" style="margin-bottom: 0;">
							<input v-model="code" class="login-user-form code-input" required name="code"
								type="number" />
						</el-form-item>

						<div class="code-btn" @click="sendCode()">{{send}}</div>
					</div>
				</el-form>

				<div class="login-msg">{{msg}}</div>

				<div class="confirm-ctr">
					<el-button type="primary" class="sms-login-btn" @click="smsLogin()">登录</el-button>
				</div>

				<div class="xy-row">

					<label>
						<input type="checkbox" v-model="isAgree">登录即表示您已阅读并同意
					</label>

					<div class="xy-row-text">
						<label class="xy-text" @click="toYhxy()">《用户协议》</label>
						与
						<label class="xy-text" @click="toYsxy()">《隐私协议》</label>
					</div>
				</div>

			</div>
			<div v-else class="login-ctr">
				<el-form>
					<el-form-item label="用户名">
						<input v-model="name" class="login-user-form" required name="name" />
					</el-form-item>

					<el-form-item label="密  码">
						<input v-model="pwd" class="login-user-form" required name="pwd" type="password" />
					</el-form-item>

				</el-form>

				<div class="login-msg">{{msg}}</div>

				<div class="confirm-ctr">
					<el-button @click="cancel()">取 消</el-button>
					<el-button type="primary" @click="confirm()">确 定</el-button>
				</div>

			</div>

		</el-dialog>

		<el-dialog :visible.sync="showUserDialog" title="用户中心" align='center'>
			<div class="create-group-ctr">

				<!-- 头像上传 -->
				<div class="group-row">
					<div class="row-title">头像</div>
					<div class="avatar-upload">
						<el-upload class="avatar-uploader" action="#" :show-file-list="false"
							:http-request="handleUploadAvatar" :before-upload="beforeAvatarUpload" accept="image/*">
							<img v-if="avatarUrl" :src="avatarUrl" class="avatar" />
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<div class="avatar-tip">支持 jpg/png，大小不超过 2MB</div>
					</div>
				</div>

				<div class="group-row">
					<div class="row-title">用户昵称</div>
					<el-input v-model="nickname" class="group-input" placeholder="用户昵称" />
				</div>

				<div class="group-row">
					<div class="row-title">手机号</div>
					<el-input class="group-input" :value="user && user.mobile" disabled />
				</div>

				<div class="group-row" v-if="user && user.parent">
					<div class="row-title">上级</div>
					<el-input class="group-input" :value="user.parent.nickname" disabled />
				</div>

			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmUserInfo()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import MenusData from './menus.json'

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		login,
		queryUser,
		sendSms,
		smsLogin
	} from "@/api/index"
	
	import {
		uploadImage,
		updateProfile
	} from "@/api/account"
	
	import {
		isEmpty
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		handleProtocal
	} from "@/utils/protocal"

	export default {
		name: "Header",
		data() {
			return {
				menus: MenusData.list,
				activeMenu: 0,
				activeChildMenu: '', // 当前激活的子菜单索引
				hoverMenuIndex: -1, // 鼠标悬停的菜单索引
				showLogin: false,
				name: '',
				pwd: '',
				msg: '',
				user: null,
				loginType: 'sms',
				isAgree: false,
				send: '获取验证码',
				code: '',
				phone: '',
				type: 2,
				logo: 'https://syzsoss.oss-cn-chengdu.aliyuncs.com/202610/21103557-96701179728691546.png',
				showUserDialog: false,
				nickname: '',
				avatarUrl: '',   // 显示用头像地址
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			// 防止浏览器刷新后 导航选中的菜单错位
			this.relocateMenu();
			this.queryUserInfo();
		},

		watch: {
			// 防止点击浏览器返回按钮后 菜单索引错误
			$route(route) {
				console.log(route)
				this.relocateMenu();
			}
		},

		methods: {
			changeMenu(index) {
				const menu = this.menus[index]
				// 如果有子菜单且有默认第一个子菜单，跳转到第一个子菜单
				if (menu.children && menu.children.length > 0) {
					this.activeMenu = index
					this.activeChildMenu = index + '-0'
					this.$router.push(menu.children[0].url)
				} else {
					if (this.activeMenu == index) {
						return;
					}
					this.activeMenu = index;
					this.activeChildMenu = ''
					this.$router.push(menu.url);
				}
			},

			// 切换子菜单
			changeChildMenu(parentIndex, childIndex) {
				const parentMenu = this.menus[parentIndex]
				if (parentMenu.children && parentMenu.children[childIndex]) {
					this.activeMenu = parentIndex
					this.activeChildMenu = parentIndex + '-' + childIndex
					this.$router.push(parentMenu.children[childIndex].url)
				}
			},

			clickLogo() {
				let location = window.location;
				let url = location.origin;
				window.location.href = url;
			},

			relocateMenu() {
				let pathname = window.location.pathname;

				// 先查找子菜单匹配
				for (let i = 0; i < this.menus.length; i++) {
					const menu = this.menus[i];
					if (menu.children) {
						for (let j = 0; j < menu.children.length; j++) {
							const child = menu.children[j];
							if (pathname.indexOf(child.url) >= 0) {
								this.activeMenu = i;
								this.activeChildMenu = i + '-' + j;
								return;
							}
						}
					}
				}

				// 再查找一级菜单匹配
				for (let i = 0; i < this.menus.length; i++) {
					let menu = this.menus[i];
					if (pathname == '/') {
						this.activeMenu = 0;
						return;
					}
					if (menu.url == '/') {
						continue
					}
					if (pathname.indexOf(menu.url) >= 0) {
						this.activeMenu = i;
						this.activeChildMenu = '';
						return;
					}
				}
			},

			clickLogin() {
				this.msg = ''
				// this.showLogin = true;
				this.loginStore.openLoginDialog()
			},

			// 登录弹窗（账号密码）的确定
			confirm() {
				if (isEmpty(this.name) || isEmpty(this.pwd)) {
					this.msg = '账号或密码不能为空'
					return;
				}

				login({
					name: this.name,
					pwd: this.pwd
				}).then(res => {
					let realData = res.data;

					this.msg = realData.toast;
					let isLogin = realData.isLogin

					if (isLogin == 1) {
						this.user = realData.user;
						this.loginStore.closeLoginDialog()
						console.log('refresh------------')
						window.location.reload();
					}
				})
			},

			queryUserInfo() {
				queryUser().then(res => {
					let realData = res.data;

					let isLogin = realData.isLogin

					if (isLogin == 1) {
						this.user = realData.user;

						// 回显头像
						if (realData.user && realData.user.avatar) {
							this.avatarUrl = realData.user.avatar;
						}
					}

					if (realData.logo) {
						this.logo = realData.logo;
					}
				})
			},

			cancel() {
				// this.showLogin = false;
				this.loginStore.closeLoginDialog()
			},

			agreeChange() {

			},

			sendCode() {
				if (!this.chenckPhone()) {
					return false
				}
				let self = this
				if (self.send == "获取验证码" || self.send == "重新发送验证码") {
					self.disabled = true;
					var time = 60; //时间
					var timer = setInterval(() => {
						time--;
						if (time >= 0) {
							self.send = "重新发送(" + time + ")";
						} else if (time < 0) {
							self.send = "重新发送验证码";
							self.disabled = false; //倒计时结束能够重新点击发送的按钮 
							clearInterval(timer); //清除定时器 
							time = 60; //设置循环重新开始条件 
						}
					}, 1000); //设置定时器 

				} else {
					this.msg = '验证码已发送'
					return false
				}
				console.log('sendSms')
				sendSms({
					phone: this.phone,
					type: this.type
				}).then(res => {})
			},

			smsLogin() {
				smsLogin({
					phone: this.phone,
					code: this.code,
					type: this.type
				}).then(res => {
					let realData = res.data;

					this.msg = realData.toast;
					let isLogin = realData.isLogin

					if (isLogin == 1) {
						this.user = realData.user;
						this.loginStore.closeLoginDialog()
						window.location.reload();
					}
				})
			},

			chenckPhone() {
				if (!this.isAgree) {
					Notification.error({
						title: '请阅读同意勾选协议'
					})
					return false
				}

				if (this.phone == '' || this.phone.length != 11) {
					Notification.error({
						title: '请输入手机号码'
					})
					return false
				}

				return true
			},

			toYhxy() {
				handleProtocal()
			},
			toYsxy() {
				handleProtocal()
			},

			/* ---------------- 用户中心：头像上传与保存 ---------------- */

			// 打开用户中心
			openUserDialog() {
				if (!this.user) return;
				this.showUserDialog = true;
				this.nickname = this.user.nickname || '';
				this.avatarUrl = this.user.avatar || '';
			},

			// 上传前校验
			beforeAvatarUpload(file) {
				const isImage = file.type.startsWith('image/');
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isImage) {
					this.$message.error('只能上传图片文件');
					return false;
				}
				if (!isLt2M) {
					this.$message.error('图片大小不能超过 2MB');
					return false;
				}
				return true;
			},

			// 自定义上传：先本地预览，再调接口
			handleUploadAvatar(options) {
				const file = options.file;

				// 本地预览
				const reader = new FileReader();
				reader.onload = (e) => {
					this.avatarUrl = e.target.result;
				};
				reader.readAsDataURL(file);

				// 调用上传接口
				this.uploadAvatarFile(file)
					.then((res) => {

						this.avatarUrl = res.url;
					})
					.catch(() => {
						this.$message.error('头像上传失败');
						this.avatarUrl = (this.user && this.user.avatar) || '';
					});
			},

			// 实际上传请求 —— 替换成你项目实际的请求封装
			uploadAvatarFile(file) {
				const formData = new FormData();
				formData.append('file', file);

				return uploadImage(formData).then(res => res.data);
			},

			// 用户中心：保存昵称和头像
			confirmUserInfo() {
				if (!this.nickname) {
					this.$message.error('昵称不能为空');
					return;
				}
				const payload = {
					nickname: this.nickname,
					avatar: this.avatarUrl || ''
				};

				updateProfile(payload).then(res => {
					this.showUserDialog = false;
					this.queryUserInfo();
				}).catch(() => {

				});
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss">
	@use "header.scss";

</style>